"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RadioGroup = _interopRequireDefault(require("./RadioGroup.style"));
var _Radio = _interopRequireDefault(require("./Radio"));
var _InputError = _interopRequireDefault(require("../errors/InputError"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); } /* eslint-disable */
var defaultoptions = [{
  value: 'yes'
}, {
  value: 'no',
  iconChecked: 'ion-close',
  iconUnchecked: 'ion-close'
}];
var RadioGroup = function RadioGroup(_ref) {
  var selectedValue = _ref.selectedValue,
    onChange = _ref.onChange,
    name = _ref.name,
    errors = _ref.errors,
    disabled = _ref.disabled,
    className = _ref.className,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? defaultoptions : _ref$options;
  return /*#__PURE__*/_react["default"].createElement(_RadioGroup["default"], {
    className: "radio-group-wrapper ".concat(className)
  }, options.map(function (option) {
    return /*#__PURE__*/_react["default"].createElement(_Radio["default"], _extends({
      key: option.value
    }, option, {
      name: name,
      disabled: disabled,
      checked: option.value === selectedValue,
      onChange: onChange
    }));
  }), errors && Array.isArray(errors) ? errors.map(function (error, index) {
    return error && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
      key: "".concat(index, "-").concat(error),
      id: "".concat(name, "Error").concat(index),
      message: error
    });
  }) : errors && /*#__PURE__*/_react["default"].createElement(_InputError["default"], {
    message: errors,
    id: "".concat(name, "Error0")
  }));
};
RadioGroup.propTypes = {
  disabled: _propTypes["default"].bool,
  errors: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]),
  name: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  selectedValue: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  className: _propTypes["default"].string
};
RadioGroup.defaultProps = {
  selectedValue: '',
  errors: '',
  onChange: function onChange() {},
  name: '',
  disabled: false,
  options: undefined,
  className: ''
};
var _default = exports["default"] = RadioGroup;